import { DateTime } from "luxon";

// extracting word after "_"
export const getSecondWord = (str: string) => {
    const parts = str.split("_");
    return parts.length > 1 ? parts[1] : "";
};

// return a short description for the tariff plan
export const getTariffDescription = (tariff: string) => {
    switch (tariff) {
        case "TARIFF_STARTER":
        case "STARTER":
            return "Available by default upon registration";
        case "TARIFF_LITE":
        case "LITE":
            return "Disables the display of ads in the online booking";
        case "TARIFF_PREMIUM":
        case "PREMIUM":
            return "Without ads and restrictions of branches and employees";
        default:
            return "Unknown tariff";
    }
};

export const calculateNextPaymentDate = (isYearly: boolean, lastPaymentDate: string) => {
    // Parse the date of the last payment
    let date = DateTime.fromFormat(lastPaymentDate, "yyyy-MM-dd");
    if (!date.isValid) {
        throw new Error("Invalid date format");
    }
    // Add the year or month depending on the isYearly value
    if (isYearly) {
        date = date.plus({ years: 1 });
    } else {
        date = date.plus({ months: 1 });
    }
    // format the date of the next payment in the required format
    return date.toFormat("dd.MM.yyyy");
};
